import {createAction, props} from '@ngrx/store';
import {UserProfile} from './auth.models';

export const authLogin = createAction('[auth] Login');
export const authLoginUsernamePassword = createAction(
    '[auth] Login Credential',
    props<{ username: string, password: string }>()
);
export const authLoginSuccess = createAction(
    '[auth] Login Success',
    props<{ userProfile: UserProfile }>()
);
export const authLoginFail = createAction(
    '[auth] Login Fail',
    props<{ err: Error }>()
);
export const authLogout = createAction('[auth] Logout');
